module.exports = __webpack_public_path__ + "static/media/chatter.086a2dbd.svg";